<main class="scaffold-container">
  <div class="card">
    <h1>{{ title }}</h1>
    <p class="status">✅ Successfully deployed</p>
    <dl>
      <dt>Environment</dt>
      <dd>{{ environment }}</dd>
      <dt>Build Time</dt>
      <dd>{{ buildTime }}</dd>
      <dt>Version</dt>
      <dd>{{ version }}</dd>
    </dl>
    <p class="note">This is a scaffold deployment. Full application coming soon.</p>
  </div>
</main>
